import { IDEMPOTENCY_KEY_REQUEST_HEADER } from '@dock/common';
// TODO: move it to lib/ level after finishing the refactoring in service layer

export const addHeader = (value: string, key = IDEMPOTENCY_KEY_REQUEST_HEADER) => ({
    headers: {
        [key]: value,
    },
});
